.page {
  display: flex;
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
}
.colorPrimary {
  background-color: white
}
.colorSecondary {
  background-color: #f5f5f5;
}
